export const headerActions: any = [
  {
    title: 'Add Receiver',
    action: 'add-receiver',
    hidden: false,
    availableOn: ['library'],
    icon: 'add-icon',
  },
];
